import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { AuthGuardService as AuthGuard } from './containers/default-layout/auth/auth-guard.service';
import { AuthService } from './containers/default-layout/auth/auth.service';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';

export const routes: Routes = [
  { path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full' },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    },
    canActivate: [AuthGuard] 
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    },
    canActivate: [AuthGuard] 
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    },
    canActivate: [AuthGuard] 
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard], 
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'devices',
        loadChildren: () => import('./views/devices/devices.module').then(m => m.DevicesModule)
      },
      {
        path: 'roles',
        loadChildren: () => import('./views/roles/role.module').then(m => m.RoleModule)
      },
      {
        path: 'employees',
        loadChildren: () => import('./views/employees/employees.module').then(m => m.EmployeesModule)
      },
      {
        path: 'schedule',
        loadChildren: () => import('./views/schedule/schedule.module').then(m => m.ScheduleModule)
      },
      {
        path: 'records',
        loadChildren: () => import('./views/records/records.module').then(m => m.RecordsModule)
      }
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [ RouterModule ],
  providers:[AuthGuard, AuthService]
})
export class AppRoutingModule {}
